import React from "react";
import { ApplicationInputStyle, applyMaxLengths } from "../../constants";
import FettiInput from "../FettiInput";
import ApplyRequiredError from "./ApplyRequiredError";
import { Box, Stack } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { updateAppData } from "../../utils/actionUtils";

const SimpleApplyField = ({
  label,
  field,
  missingMsg,
  placeholder,
  valueFunc = null,
  optional = false,
}) => {
  const dispatch = useDispatch();
  const appData = useSelector((state) => state.apply.app);
  return (
    <Stack
      {...ApplicationInputStyle.stackProps}
      sx={ApplicationInputStyle.stack}>
      <Box sx={ApplicationInputStyle.header}>
        {label}
        {optional && (
          <span style={ApplicationInputStyle.optional}> (optional)</span>
        )}
      </Box>
      <FettiInput
        value={appData[field]}
        placeholder={placeholder}
        onChange={(v) =>
          updateAppData(dispatch, {
            [field]: valueFunc ? valueFunc(v.target.value) : v.target.value,
          })
        }
        maxLength={applyMaxLengths[field]}
      />
      <ApplyRequiredError field={field} msg={missingMsg} />
    </Stack>
  );
};

export default SimpleApplyField;
